export default __webpack_public_path__ + "static/media/brush15.c85fa3ab.png";